"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_stripe_js_1 = require("@stripe/react-stripe-js");
const stripe_js_1 = require("@stripe/stripe-js");
const styled_components_1 = require("styled-components");
const requests_1 = require("../requests");
const CheckoutForm_1 = __importDefault(require("./CheckoutForm"));
function Checkout({ stripeApiKey, tipAmount, onClose, interviewToken, tippingPlacement, }) {
    const [clientSecret, setClientSecret] = (0, react_1.useState)();
    const [customerId, setCustomerId] = (0, react_1.useState)("");
    const theme = (0, styled_components_1.useTheme)();
    const stripePromise = (0, react_1.useMemo)(() => (0, stripe_js_1.loadStripe)(stripeApiKey), [stripeApiKey]);
    (0, react_1.useEffect)(() => {
        // Create PaymentIntent as soon as this component loads
        (0, requests_1.createPaymentIntent)({ tip: tipAmount })
            .then((data) => {
            setClientSecret(data.clientSecret);
            setCustomerId(data.customerId);
        })
            .catch(console.error);
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { className: "App", children: clientSecret && ((0, jsx_runtime_1.jsx)(react_stripe_js_1.Elements, { options: {
                clientSecret,
                appearance: {
                    theme: "stripe",
                    variables: {
                        colorPrimary: theme.palette.primary.main,
                        colorText: theme.palette.text.primary,
                        colorDanger: theme.palette.status.error,
                        fontFamily: theme.typography.FontFamily.Primary,
                        borderRadius: "4px",
                        fontSizeBase: "16px",
                        colorTextPlaceholder: theme.palette.gray[60],
                    },
                },
                fonts: [
                    {
                        family: "GT Eesti Display",
                        src: "url(https://static.buoyhealth.com/fonts/GT-Eesti-Display-Regular.woff2)",
                        weight: "400",
                    },
                ],
            }, stripe: stripePromise, children: (0, jsx_runtime_1.jsx)(CheckoutForm_1.default, { customerId: customerId, onClose: onClose, tipAmount: tipAmount, interviewToken: interviewToken, tippingPlacement: tippingPlacement }) })) }));
}
exports.default = Checkout;
//# sourceMappingURL=Checkout.js.map